export var cibLogstash = ["32 32", "<path d='M16.802 9.599v22.401c-6.938 0-14.401-5.333-14.401-12.401v-19.599h4.797c5.068 0 9.604 4.531 9.604 9.599zM20 17.599v14.401h9.599v-14.401z'/>"];
